/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  gutterBottom: {
    marginBottom: 8
  }
};
